export interface FrenchBank {
  name: string;
  /**
   * Brandfetch domain key. Omitted for banks whose logo we can't reliably
   * fetch (defunct/merged regional networks, unverified domains) — BankLogo
   * falls back to a generic initial in that case.
   */
  domain?: string;
}

export const OTHER_BANK_VALUE = 'OTHER';

export const FRENCH_BANKS: FrenchBank[] = [
  { name: 'Crédit Agricole', domain: 'credit-agricole.fr' },
  { name: 'BNP Paribas', domain: 'bnpparibas.fr' },
  { name: 'Société Générale', domain: 'societegenerale.fr' },
  { name: 'Crédit Mutuel', domain: 'creditmutuel.fr' },
  { name: 'CIC', domain: 'cic.fr' },
  { name: 'Banque Populaire', domain: 'banquepopulaire.fr' },
  { name: "Caisse d'Épargne", domain: 'caisse-epargne.fr' },
  { name: 'La Banque Postale', domain: 'labanquepostale.fr' },
  { name: 'LCL', domain: 'lcl.fr' },
  { name: 'CCF', domain: 'ccf.fr' },
  { name: 'BoursoBank', domain: 'boursobank.com' },
  { name: 'Fortuneo', domain: 'fortuneo.fr' },
  { name: 'Hello bank!', domain: 'hellobank.fr' },
  { name: 'Monabanq', domain: 'monabanq.com' },
  { name: 'N26', domain: 'n26.com' },
  { name: 'Revolut', domain: 'revolut.com' },
  { name: 'Qonto', domain: 'qonto.com' },
  { name: 'Shine', domain: 'shine.fr' },
  { name: 'Nickel', domain: 'compte-nickel.fr' },
  { name: 'AXA Banque', domain: 'axabanque.fr' },
  { name: 'BforBank', domain: 'bforbank.com' },
  { name: 'Crédit Coopératif', domain: 'credit-cooperatif.coop' },
  { name: 'HSBC Continental Europe', domain: 'hsbc.fr' },
  { name: 'ING', domain: 'ing.fr' },
  { name: 'Banque Palatine', domain: 'banquepalatine.com' },
  { name: 'Milleis Banque', domain: 'milleis.fr' },
  { name: 'Neuflize OBC', domain: 'neuflize.com' },
  { name: 'Orange Bank', domain: 'orangebank.fr' },
  { name: 'Younited', domain: 'younited-credit.com' },
  { name: 'Lydia', domain: 'lydia-app.com' },
  // Former Crédit du Nord regional networks, absorbed into other brands
  // since 2023 — no reliable domain/logo, name-only entries.
  { name: 'Banque Populaire du Nord' },
  { name: 'Banque de Savoie' },
  { name: 'Crédit du Nord' },
  { name: 'Banque Courtois' },
  { name: 'Banque Nuger' },
  { name: 'Banque Marze' },
  { name: 'Banque Rhône-Alpes' },
  { name: 'Banque Tarneaud' },
  { name: 'Banque Kolb' },
  { name: 'Banque Laydernier' },
  { name: 'Banque de Wallis et Futuna' },
];
